import { render, staticRenderFns } from "./MyDashboardMyFriends.vue?vue&type=template&id=1e51bee4&scoped=true&lang=pug&"
import script from "./MyDashboardMyFriends.vue?vue&type=script&lang=js&"
export * from "./MyDashboardMyFriends.vue?vue&type=script&lang=js&"
import style0 from "./MyDashboardMyFriends.vue?vue&type=style&index=0&id=1e51bee4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51bee4",
  null
  
)

export default component.exports